import { STATUS_TONE_CLASS, type StatusTone } from "@/lib/status-tone";

// TES-1037 — the status tag: a filled pill whose colour carries one of five
// meanings (see STATUS_TONE_CLASS). `subordinate` is for a status that follows
// from another row's — smaller and quieter, so it does not read as a finding
// of its own.
export function StatusTag({
  tone,
  children,
  subordinate = false,
}: {
  tone: StatusTone;
  children: React.ReactNode;
  subordinate?: boolean;
}) {
  return (
    <span
      className={`inline-flex max-w-full shrink-0 rounded-full px-sm py-[2px] text-xs ${
        subordinate ? "font-normal" : "font-semibold"
      } ${STATUS_TONE_CLASS[tone]}`}
    >
      {children}
    </span>
  );
}
